<ng-container cdkDropListGroup>
  <aside class="job-list">
    <header class="shadow-sm">
      <app-assign-board-controls (assign)="assignSelectedActionsTo($event)"
                                 (delete)="deleteSelectedActions()"
                                 [count]="unassignedActions?.length"
                                 [teams]="teams"
                                 [enableMenu]="selectedActions?.length > 0"></app-assign-board-controls>
    </header>
    <div>
      <div class="scroll-view">

        <mdb-spinner *ngIf="loading"
                     spinnerColor="blue"
                     spinnerType="small"></mdb-spinner>
        <section (cdkDropListDropped)="unassign($event)"
                 [cdkDropListEnterPredicate]="canUnassign.bind(this)"
                 cdkDropList
                 class="action-list">
          <app-draggable-action (assign)="assignActionToTeam($event)"
                                (delete)="deleteSingle(action)"
                                *ngFor="let action of unassignedActions"
                                [cdkDragData]="action"
                                [model]="action"
                                [selectable]="true"
                                [subTitle]="ActionSubTitle.Location"
                                [teams]="teams"
                                cdkDrag
          >
            <span statusView>{{ this.localisedStatusFor(action) }} <i class="fa fa-caret-down"></i></span>
          </app-draggable-action>
        </section>
      </div>

    </div>

  </aside>
  <aside>
    <div class="scroll-view">
      <div class="intervention-teams-view">
        <header>
          <h4 [translate]="Localization.InterventionTeams"></h4>
          <chapps-secondary-button (click)="sendAssignedActions()"
                                   *ngIf="hasUnsentActions"
                                   [label]="(Localization.Send | translate) + ' ('+totalUnsentActions+')'"
                                   [loading]="isSendingActions"
                                   [small]="true">
          </chapps-secondary-button>
        </header>
        <section class="team-list">

          <mdb-spinner spinnerType="big"
                       spinnerColor="blue"
                       *ngIf="loading"></mdb-spinner>

          <ng-container *ngFor="let team of teams">
            <app-intervention-team-card [team]="team"
                                        class="clickable"
                                        [class.active]="isSelected(team)"
                                        (click)="select(team)"
                                        cdkDropList
                                        (cdkDropListDropped)="didDrop($event, team)"
            >

            </app-intervention-team-card>
          </ng-container>
        </section>
      </div>
    </div>
  </aside>
  <main>

    <ng-container *ngIf="!isLoadingDetail; else loadingView">

      <ng-container *ngIf="selectedTeam; else noSelectionView">
        <div (cdkDropListDropped)="didDrop($event, selectedTeam)"
             cdkDropList
             class="scroll-view">
          <div class="intervention-team-detail-view">

            <header>
              <h2>{{ selectedTeam.label }}</h2>
              <i class="fa fa-arrow-up-right-from-square clickable"
                 [routerLink]="'/maintenance/intervention-teams/teams/'+selectedTeam.id"></i>
            </header>
            <section class="team-actions">
              <app-action-detail *ngFor="let action of selectedTeamActions"
                                 [action]="action"></app-action-detail>

            </section>

          </div>
        </div>
      </ng-container>

    </ng-container>
  </main>
</ng-container>
<ng-template #noSelectionView>
  <figure class="empty-state">
    <svg class="sprite icon">
      <use xlink:href="#external-teams-solid"></use>
    </svg>
    <figcaption>{{ Localization.EmptyProcessingScreenMessage | translate }}</figcaption>
  </figure>
</ng-template>
<ng-template #loadingView>
  <mdb-spinner spinnerType="big"
               spinnerColor="blue"></mdb-spinner>
</ng-template>
